var map = {
	"./zxh_1.png": "GTrQ",
	"./zxh_1_tw.png": "ruP3",
	"./zxh_2.png": "II3w",
	"./zxh_2_tw.png": "aYiA",
	"./zxh_3.png": "o27S",
	"./zxh_3_tw.png": "8tQb"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "hIF2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/slwh ^\.\/zxh_.*\.png$
// module id = hIF2
// module chunks = 0